// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".shimmer[data-v-15a516e0]:after{animation:shimmer-15a516e0 2s ease-out infinite;background-image:linear-gradient(90deg,#e9e9e9,hsla(0,0%,91%,.9) 50%,hsla(0,0%,91%,.8));bottom:0;content:\"\";left:0;position:absolute;right:0;top:0;transform:translateX(-100%)}@keyframes shimmer-15a516e0{to{opacity:0;transform:translateX(0)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
